module.exports = __webpack_public_path__ + "static/media/more-all-products-7.6e32e174.png";